import apiService from '@/Common/ApiService'
import Utility from '@/Common/Utility'
import Vue from 'vue'
import router from '@/router'
import Router from 'vue-router'


let ControlBase = {
    vueInstance: null,
    editingAreaElement: null,

    ControlInstanceVues: [],

    ConvertToBoolean: function (string) {
        switch (string.toLowerCase().trim()) {
            case "true": case "yes": case "1": return true;
            case "false": case "no": case "0": case null: return false;
            default: return Boolean(string);
        }
    },


    ConvertObjectToXml(dataObject, tagName) {
        let dataXml = "";
        let contentXml = "";
        let childNode;
        let childObject;
        let beginTag, endTag;
        let controlChildCount = 0;
        let childTagName;
        let sourcePropertyName;
        let i, j;



        if (dataObject != null && typeof (dataObject) == "object" && Array.isArray(dataObject)) {
            beginTag = `    <${tagName} Type="Array" >
`;
        }
        else if (dataObject != null && typeof (dataObject) == "object" && !Array.isArray(dataObject)) {
            beginTag = `    <${tagName} Type="Object" >
`;
        }
        else {
            beginTag = `    <${tagName}>
`;
        }

        endTag = `    </${tagName}>
`;

        if (typeof (dataObject) == "object" && !Array.isArray(dataObject)) {

            for (i in dataObject) {
                if (i != "ControlId" && i != "ControlName") {
                    if (i.indexOf("$NotCommitted") > 0) {
                        sourcePropertyName = i.replace("$NotCommitted", "");
                        dataObject[sourcePropertyName] = dataObject[i];
                        delete dataObject[i];
                    }
                }
            }

            for (i in dataObject) {
                if (i != "ControlId" && i != "ControlName") {
                    contentXml +=
                        "    " + this.ConvertObjectToXml(dataObject[i], i) + "\r\n";
                }
            }
        }
        else if (dataObject != null && Array.isArray(dataObject)) {

            for (i = 0; i < dataObject.length; i++) {
                childTagName = tagName.replace("list", "");
                contentXml +=
                    "    " + this.ConvertObjectToXml(dataObject[i], childTagName) + "\r\n";
            }
        }
        else {
            contentXml += dataObject;
        }


        dataXml = beginTag + contentXml + endTag;

        //if (dataXml.indexOf(`type="Array"`) >= 0) {
        //    debugger;
        //}

        return dataXml;
    },


    ConvertNodeToObject(dataNode) {
        let childNode;
        let childObject;
        let dataObject = null;
        let leafNode = false;
        let controlChildCount = 0;
        let i, j;


        if (dataNode != null) {
            if (dataNode.getAttribute("Type") == "Array") {
                dataObject = [];
            }
            else if (dataNode.getAttribute("Type") == "Object") {
                dataObject = {};
            }
            else if (dataNode.getAttribute("Type") == "Number") {
                dataObject = new Number(dataNode.innerHTML);
                leafNode = true;
            }
            else if (dataNode.getAttribute("Type") == "Boolean") {
                dataObject = this.$ConvertToBoolean(dataNode.innerHTML);
                leafNode = true;
            }
            else if (dataNode.getAttribute("Type") == "Text" || dataNode.getAttribute("Type") == "Html") {
                dataObject = dataNode.innerHTML;
                leafNode = true;
            }
            else if (dataNode.getAttribute("Type") == null && dataNode.children.length > 0) {
                dataObject = dataNode.innerHTML;
                leafNode = true;
            }
            else if (dataNode.children.length == 0) {
                dataObject = dataNode.innerHTML;
                leafNode = true;
            }
        }

        if (!leafNode) {
            for (i = 0; i < dataNode.children.length; i++) {
                childNode = dataNode.children[i];

                if (childNode.tagName.toLowerCase() != "control") {
                    childObject = this.ConvertNodeToObject(childNode);

                    if (dataNode.getAttribute("Type") == "Object") {
                        dataObject[childNode.tagName.toLowerCase()] = childObject;
                    }
                    else if (dataNode.getAttribute("Type") == "Array") {
                        dataObject.push(childObject);
                    }
                    else {
                        throw ("Error ! Non object type data has more than one child !");
                    }
                }
            }
        }

        return dataObject;
    },


    HasParentPlugableControl(controlElement) {
        let parentElement;
        let hasParentControl = false;


        parentElement = controlElement.parentElement;

        while (true) {
            if (parentElement.tagName == "CONTROL") {
                hasParentControl = true;
                break;
            }
            else if (parentElement.tagName == "BODY") {
                break;
            }
            else {
                parentElement = parentElement.parentElement;
            }
        }

        return hasParentControl;
    },


    GetVueInstance() {
        return this.$base.vueInstance;
    },


    Initialize(vueInstance, editingAreaElement) {
        this.editingAreaElement = editingAreaElement;
        this.vueInstance = vueInstance;

        if (this.editingAreaElement == null) {
            this.editingAreaElement = this.vueInstance.$el;
        }
    },



    ProcessContent(clearInstances = true) {
        let controlElements;
        let hasChildControl = false;
        let firstLevelControlElements = [];
        let firstLevelControlCount = 0;
        let finishedFirstLevelControlCount = 0;
        let i;



        console.log("ControlBase.ProcessContent()");

        if (clearInstances) {
            this.ClearControlInstanceVues();
        }

        controlElements = this.editingAreaElement.querySelectorAll("control");
         
        for (i = 0; i < controlElements.length; i++) {
            let controlName;
            let controlElement;
            let scriptElement;
            let dataObject;


            if (!this.HasParentPlugableControl(controlElements[i])) {
                firstLevelControlElements.push(controlElements[i]);
                firstLevelControlCount++;
            }
            else {
                hasChildControl = true;
            }
        }

        try {
            for (i = 0; i < firstLevelControlElements.length; i++) {
                let controlName;
                let controlElement;
                let scriptElement;
                let dataObject;


                controlElement = firstLevelControlElements[i];
                controlName = controlElement.getAttribute("Name");

                scriptElement = controlElement.querySelector("data");
                scriptElement.setAttribute("Type", "Object");

                try {
                    dataObject = this.ConvertNodeToObject(scriptElement);
                }
                catch (ex) { 
                    alert("ProcessContent(),this.ConvertNodeToObject() Error ! :" + ex);
                }


                import('/Src/PlugableControls/' + controlName).then(
                    function (dataObject, module) {
                        let controlId;
                        let beginCommentNode, endCommentNode;
                        let v;


                        if (dataObject != null) {
                            module.default.data = dataObject;
                        }

                        controlId = "ControlElement_" + ControlBase.ElementSerialNo++;

                        module.default.data.ControlId = controlId;
                        module.default.data.ControlName = controlName;

                        v = new Vue(module.default);

                        v.$mount(controlElement);

                        this.ControlInstanceVues.push(v);

                        finishedFirstLevelControlCount++;

                        if (
                            hasChildControl &&
                            finishedFirstLevelControlCount == firstLevelControlCount
                        ) {
                            this.ProcessContent(false);
                        }

                      
                    }.bind(this, dataObject)
                );
            }//end for (i = 0; i < controlElements.length; i++) {
        }
        catch (e) {
            debugger;
            alert(e);
        }
    },


    GetInnerHtml() {
        let innerHTML;
        let beginRegex = /<!--Control (ControlElement_[0-9]+) Begin-->/i;
        let beginMatch;
        let controlId;
        let headHtml, tailHtml;
        let controlXml;
        let beginCommentText, endCommentText;
        let beginCommentStartIndex, endCommentStartIndex;
        let dataAttributeRegex = /data-v-[a-z|0-9]+="[^"]*"/ig;
        let i;



        innerHTML = this.editingAreaElement.innerHTML;
        innerHTML = innerHTML.replace(dataAttributeRegex, "");

        while (true) {

            beginMatch = beginRegex.exec(innerHTML);

            if (beginMatch == null) {
                break;
            }

            beginCommentStartIndex = beginMatch.index;

            controlId = beginMatch[1];

            endCommentText = "<!--Control " + controlId + " End-->";

            endCommentStartIndex = innerHTML.indexOf(endCommentText);

            headHtml = innerHTML.substr(0, beginCommentStartIndex);
            controlXml = this.GenerateControlXml(controlId);
            tailHtml = innerHTML.substr(endCommentStartIndex + endCommentText.length);

            innerHTML = headHtml + controlXml + tailHtml;
        }//end  while (true) {

        return innerHTML;
    },


    GetOuterHtml() {
        let outerHTML;
        let beginRegex = /<!--Control (ControlElement_[0-9]+) Begin-->/i;
        let endRegex = /<!--Control (ControlElement_[0-9]+) End-->/i;
        let beginMatches;
        let beginMatch;
        let controlId;
        let endMatchText;
        let headHtml, tailHtml;
        let controlXml;
        let beginCommentText, endCommentText;
        let beginCommentStartIndex, endCommentStartIndex;
        let dataAttributeRegex = /data-v-[a-z|0-9]+="[^"]*"/ig;
        let i;



        outerHTML = this.editingAreaElement.outerHTML;
        outerHTML = outerHTML.replace(dataAttributeRegex, "");

        while (true) {

            beginMatch = beginRegex.exec(outerHTML);

            if (beginMatch == null) {
                break;
            }

            beginCommentStartIndex = beginMatch.index;

            controlId = beginMatch[1];

            endCommentText = "<!--Control " + controlId + " End-->";

            endCommentStartIndex = outerHTML.indexOf(endCommentText);

            headHtml = outerHTML.substr(0, beginCommentStartIndex);
            controlXml = this.GenerateControlXml(controlId);
            tailHtml = outerHTML.substr(endCommentStartIndex + endCommentText.length);

            outerHTML = headHtml + controlXml + tailHtml;
        }//end  while (true) {

        return outerHTML;
    },


    GenerateControlXml(controlId) {
        let controlXml = "";
        let controlVueInstance = null;
        let dataObject;
        let i;


        for (i = 0; i < this.ControlInstanceVues.length; i++) {
            if (this.ControlInstanceVues[i].$el.getAttribute("ControlId") == controlId) {
                controlVueInstance = this.ControlInstanceVues[i];
                break;
            }
        }

        if (controlVueInstance == null) {
            alert("can not find vueInstance " + controlId);
            return "";
        }

        controlXml = `
<control Name="${controlVueInstance.$data.ControlName}">
`;

        dataObject = {};
        Object.assign(dataObject, controlVueInstance.$data);


        delete dataObject.ControlId;
        delete dataObject.ControlName;

        controlXml += this.ConvertObjectToXml(controlVueInstance.$data, "data");

        controlXml += `</control>
`;
         
        return controlXml;
    },


    CreateBeginEndComment() {
        let beginCommentNode, endCommentNode;
        let controlElement;
        let controlId;


        this.ControlInstanceVues.forEach(
            (vueInstance) => {
                controlElement = vueInstance.$el;

                controlId = controlElement.getAttribute("ControlId");

                beginCommentNode = document.createComment(`Control ${controlId} Begin`);
                controlElement.parentNode.insertBefore(beginCommentNode, controlElement);

                endCommentNode = document.createComment(`Control ${controlId} End`);
                controlElement.parentNode.insertBefore(endCommentNode, controlElement.nextSibling);
            }
        );

        this.GetOuterHtml();
    },


    ClearControlInstanceVues() {
        let i;


        this.ControlInstanceVues.forEach(
            (controlInstanceVue) => {
                controlInstanceVue.$destroy();
            }
        );

        for (i = 0; i < this.ControlInstanceVues.length; i++) {
            delete this.ControlInstanceVues[i];
        }

        this.ControlInstanceVues.length = 0;
    },


    DestoryControl() {
        this.ClearControlInstanceVues();
    },

    OnInput(e, dataObject, propertyName, newValue) {
        if (e.inputType == "historyRedo" || e.inputType == "historyUndo") {
            dataObject[propertyName + "$NotCommitted"] = newValue;

            this.ProcessContent(false);
        }
    },


    OnBlur(event, dataObject, propertyName, newValue) {
        dataObject[propertyName] = newValue;

        this.ProcessContent();

        delete dataObject[propertyName + "$NotCommitted"];
    },

    install: function (Vue, options) {

        // create a mixin 
        Vue.mixin({
            mounted() {

            }
        });

        Vue.prototype.$GetInstance = function () {
            this.vueInstance = this;

            return this.vueInstance;
        }



        Vue.prototype.$base = this;
    }
}//end let ControlBase = {



ControlBase.ElementSerialNo = 1;


export default ControlBase;
